module.exports = __webpack_public_path__ + "static/media/calendar-add.f3aa5ae2.svg";